// src/store/loginAndOut.js
import apiClient from "../plugins/axios";
import { jwtDecode } from "jwt-decode";
import router from "@/router";

export default {
  namespaced: true,

  state: {
    token: localStorage.getItem("token") || "",
    isLoading: false,
    name: localStorage.getItem("name") || "",
    email: localStorage.getItem("email") || "",
    isTokenVerified: false,
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
      try {
        const decoded = jwtDecode(token);
        state.role = decoded.role;
      } catch (error) {
        console.error("Failed to decode token:", error);
      }
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_NAME(state, name) {
      state.name = name;
      localStorage.setItem("name", name);
    },
    SET_EMAIL(state, email) {
      state.email = email;
      localStorage.setItem("email", email);
    },
    SET_TOKEN_VERIFIED(state, isVerified) {
      state.isTokenVerified = isVerified;
    },
    CLEAR_AUTH(state) {
      state.token = "";
      state.role = "";
      state.name = "";
      state.email = "";
      state.isTokenVerified = false;
      localStorage.removeItem("token");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
    },
  },

  actions: {
    async login({ commit }, credentials) {
      commit("SET_LOADING", true);
      try {
        const response = await apiClient.post("/login", credentials, {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        });
        commit("SET_TOKEN", response.data.token);
        commit("SET_NAME", response.data.name);
        commit("SET_EMAIL", response.data.email);
      } catch (error) {
        console.error("Login failed:", error);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async verifyToken({ commit, state }, { username, token }) {
      commit("SET_LOADING", true);
      try {
        const response = await apiClient.post(
          "/login/verifyToken",
          {
            username,
            token,
            authToken: state.token,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          commit("SET_TOKEN_VERIFIED", true);
          router.push("/");
        } else {
          throw new Error("Token verification failed");
        }
      } catch (error) {
        console.error("Token verification failed:", error);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    logout({ commit }) {
      commit("CLEAR_AUTH");
      router.push("/login");
    },
  },
};
